export const curYear = new Date().getUTCFullYear();

export const isIso8601Date = (date) => /^\d{4}-\d{2}-\d{2}$/.test(date);

export function iso8061ToYYYY(value) {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  return date.getUTCFullYear().toString();
}

export function yearMonthToIso8061(year, month = 1) {
  return `${year}-${month < 10 ? `0${month}` : `${month}`}-01`;
}

export function iso8061ToYearMonth(value) {
  if (!value) {
    return {
      month: '',
      year: '',
    };
  }
  const date = new Date(value);
  // return string values of month and year
  // input values generally want strings
  return {
    // getUTCMonth is zero indexed, while <MonthOptions /> and iso 8061 is one indexed
    month: `${date.getUTCMonth() + 1}`,
    year: `${date.getUTCFullYear()}`,
  };
}

export function YYYYtoIso8061(value) {
  // just append Jan. 1st
  return value ? `${value}-01-01` : null;
}

export function MMYYYYtoIso8601(value) {
  // if incomplete, just return the value instead of incomplete output
  // eslint-disable-next-line react/destructuring-assignment
  if (value.length !== 9) {
    return null;
  }
  // eslint-disable-next-line react/destructuring-assignment
  const parts = value.split(' / ');
  // swap year and month around into YYYY-MM-01
  // if parts[1] undefined (mid-typing), then send back incomplete date
  return `${parts[1] ? parts[1] : ''}-${parts[0]}-01`;
}

/**
 * Gets an array of years between the specified start and end year.
 *
 * @param {Number} min Minimum year
 * @param {Number} max Maximum year
 */
export function getYearArray(min, max) {
  return Array.from({ length: (max + 1) - min }, (v, year) => year + min);
}
